"use strict";
// packages/contracts/src/documento-fiscal.ts — Fase 10, Plano 01 (REM-05, D-01, D-02, D-25, D-34).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=documento-fiscal.js.map